import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClientList } from 'store/clientSlice';
import { getVendorBillDetailsV2 } from 'store/vendorBillSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { Box } from 'atoms';
import { VendorBillEditForm } from 'components/forms/vendor-bill-generation';

export default function VendorBillEditing() {
	const { id } = useParams();
	const [formData, setFormData] = useState({});
	const uiVersion = getUIVersion();

	const useV2API = uiVersion === 'new';

	const dispatch = useDispatch();
	useEffect(() => {
		if (id) {
			const action = useV2API
				? getVendorBillDetailsV2({ id })
				: getClientList({
						search_type: 'vendor_bill_details',
						filter_by: {
							id,
							is_editable: true,
						},
				  });

			dispatch(action).then((res) => {
				console.log('res', res);
				setFormData(res?.data?.vendor_bill);
			});
		}
	}, [dispatch, id, useV2API]);

	return (
		<Box>
			<VendorBillEditForm isEditMode={Boolean(id)} formData={formData} />
		</Box>
	);
}
